"use client";

import { useSearchParams } from "next/navigation";

import { InfoBlock } from "@/components";

const SessionExpWarninig = () => {
    const params = useSearchParams();

    if (params.has("sex")) {
        return <InfoBlock text="Время сессии истекло. Пожалуйста, войдите снова" />;
    } else {
        return null;
    }
};

export default SessionExpWarninig;
